import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerInitiatePrePaidPaymentApiCallSuccess, triggerTxnStatusApiCall } from 'redux/actions';
import { TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerInitiatePrePaidPaymentApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	let url = API_CONSTANT.URL.PREPAID_INITIATE_PAYMENT;
	const TXN_ID = data['txnId'];
	const PATH = data['path'];
	url = TXN_ID ? API_CONSTANT.URL.PREPAID_INITIATE_PAYMENT + API_CONSTANT.QUERY_PARAMS.TXN_ID + TXN_ID : url;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url,
		data,
		method: TXN_ID ? 'GET' : 'POST',
		options: {
			defaultLoader: !stopLoader,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		if (apiData) {
			apiData['path'] = 'home';
			localStorage.setItem('txn', 'true');
			callback && callback(apiData);
			yield put(triggerInitiatePrePaidPaymentApiCallSuccess(apiData));
			yield put(
				triggerTxnStatusApiCall({
					txnId: apiData?.['txnId'],
					path: PATH,
				}),
			);
		}
	}
}

export default function* triggerInitiatePrePaidPaymentApiCallSaga() {
	yield takeEvery(TRIGGER_INITIATE_PREPAID_PAYMENT_API_CALL, triggerInitiatePrePaidPaymentApiCall);
}
